<template>
	<div class="app-cta-container app-cta-container-mobile">
		<a
			v-if="appUrl"
			:href="appUrl"
			@click="onButtonClick"
			class="app-cta-button is-mobile"
			data-test="app-cta-button"
			target="_blank"
			title="Get the WordFinder App"
		>
			GET THE APP
		</a>
	</div>
</template>

<script>
export default {
	name: "AppCTA",
	data() {
		return {
			isSupportedMobileOS: false,
		};
	},
	computed: {
		appUrl() {
			if (!this.isSupportedMobileOS) return "";

			return this.isGetTheAppPage
				? "https://wordfinder.onelink.me/NEup/82f509f9"
				: "https://wordfinder.onelink.me/NEup/18927699";
		},
	},
	methods: {
		onButtonClick() {
			this.$store.dispatch("trackEvent", {
				eventCategory: "App CTA",
				eventAction: "Click mobile button",
			});
		},
	},
	mounted() {
		if (typeof window.navigator === "undefined") return false;

		const agent = window.navigator.userAgent;
		const isAndroid = new RegExp("Android", "i").test(agent);
		const isIos = new RegExp(
			"\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
			"i"
		).test(agent);

		this.isSupportedMobileOS = isIos || isAndroid;
	},
};
</script>

<style lang="scss" scoped src="./buttons.scss"></style>
